<template>
  <transition name="fade">
    <div v-show="visible" class="back-to-top" @click="scrollToTarget" :style="{
        right: mobile ? '10px' : '40px',
        bottom: mobile ? '70px' : '40px',
        width: mobile ? '40px' : '50px',
        height: mobile ? '40px' : '50px'
      }">
      <svg viewBox="0 0 24 24" class="icon">
        <!-- 默认显示向下箭头（去底部），到底部时才显示向上箭头（回顶部） -->
        <path
          :d="showBackToTop ? 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' : 'M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z'" />
      </svg>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'BackToTop',
    data() {
      return {
        visible: false,
        mobile: false,
        showBackToTop: false // false=显示向下箭头（去底部），true=显示向上箭头（回顶部）
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
      this.checkIfMobile()
      window.addEventListener('resize', this.checkIfMobile)
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll)
      window.removeEventListener('resize', this.checkIfMobile)
    },
    methods: {
      handleScroll() {
        const scrollPosition = window.pageYOffset
        const windowHeight = window.innerHeight
        const documentHeight = document.documentElement.scrollHeight

        // 是否到达底部（距离底部小于50px算作到达底部）
        const isAtBottom = scrollPosition + windowHeight >= documentHeight - 50

        // 默认显示“去底部”箭头，只有到达底部时才显示“回顶部”箭头
        this.showBackToTop = isAtBottom

        // 滚动超过300px时显示按钮（无论是否在底部）
        this.visible = scrollPosition > 100
      },
      scrollToTarget() {
        if (this.showBackToTop) {
          // 当前在底部，点击后滚动到顶部
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        } else {
          // 当前不在底部，点击后滚动到底部
          window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: 'smooth'
          })
        }
      },
      checkIfMobile() {
        this.mobile = window.innerWidth <= 768
      }
    }
  }
</script>

<style scoped>
  .back-to-top {
    position: fixed;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #13af87;
    border-radius: 50%;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    transition: all 0.3s;
    z-index: 999;
  }

  .back-to-top:hover {
    background-color: #46d24f;
    transform: scale(1.1);
  }

  .icon {
    fill: white;
    width: 50%;
    height: 50%;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>